import { filterSchema } from './team-list-filter.schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';

export function TeamListFilter() {
  const { register } = useFilterForm(filterSchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på namn..." />
    </Table.Bar>
  );
}
